//export const LAZY_DELAY = 0
export const TITLE_SEPARATOR = " - ";
export const MEDIA_PER_PAGE = 60;
export const FLUID_AT = true;
export const STANDARD_SPACING = 3;
export const SELECT_LIMIT = 20;
export const DEFAULT_TABLE_PROPS = { bordered: true, responsive: true, className: "mb-0" };
export const DEFAULT_AUTO_SUBMIT = { touch: 1000 };
export const SEARCH_AUTO_SUBMIT = { touch: 1000 };
export const TEXTAREA_ROWS = 8;
export const ACE_EDITOR_HEIGHT = "50em";
export const NOT_FOUND_COLOR = "666666";
export const DEFAULT_MODAL_PROPS = { size: "xl", centered: true };
export const CONTROL_POINT_RANGE = 10;
export const CONTROL_POINT_MAXIMUM_RANGE = 100;
export const MAX_CAMERA_WIDTH = "48rem";
